import BarChart from '@/components/charts/BarExample'
export default {
  name: 'report',
  components: {BarChart},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      statusNormalizer (node) {
        return {
          id: node.id,
          label: node.code,
          children: node.children
        }
      },
      status: null,
      loading: true,
      type: '0',
      quarter: '',
      year_quarter: '',
      from_year: '',
      to_year: '',
      errors: [],
      organization_id: null
    }
  },
  computed: {
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    years () {
      var years = []
      var currentYear = new Date().getFullYear()
      for (var i = 20; i > 0; i--, currentYear--) {
        years.push(currentYear)
      }
      return years
    },
    labels () {
      return this.$store.getters['Report/getTime']
    },
    datasets () {
      return this.$store.getters['Report/getReport']
    },
    list_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    get_type () {
      return this.$store.getters['Report/getType']
    },
    organization () {
      return this.$store.getters['Report/getOrganization']
    },
    start_year () {
      return this.$store.getters['Report/getStartYear']
    },
    end_year () {
      return this.$store.getters['Report/getEndYear']
    }
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}),
      this.$store.dispatch('ChecklistItemStatus/getListStatus')
    ]).then(() => {
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      console.log(errors)
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    report () {
      if (!this.organization_id) {
        this.errors = {
          organization_id: [
            'organization_id is required'
          ]
        }
        return false
      }
      var data = {}
      data.quarter = this.type
      data.year_quarter = this.year_quarter
      data.from_year = this.from_year
      data.to_year = this.to_year
      data.stt = this.status
      this.$loading.start()
      this.$store.dispatch('Report/organizationReport', {organization: {id: this.organization_id}, data}).then(res => {
        this.$loading.complete()
        this.errors = []
      }).catch(errors => {
        console.log(errors)
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },
    reportHashtag () {
      this.$router.push('/report-hashtag')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report/report.js